import { FSA } from 'flux-standard-action';
import {
  BOOKABLE_GROUP_FETCH_REQUESTED,
  BOOKABLE_GROUP_FETCH_SUCCEEDED,
  BOOKABLE_GROUP_FETCH_FAILED,
  BOOKABLE_GROUP_SAVE_REQUESTED,
  BOOKABLE_GROUP_SAVE_SUCCEEDED,
  BOOKABLE_GROUP_SAVE_FAILED,
  BOOKABLE_GROUP_DELETE_REQUESTED,
  BOOKABLE_GROUP_DELETE_SUCCEEDED,
  BOOKABLE_GROUP_DELETE_FAILED,
} from './action-types';

type state = { status: string; data: { [key: string]: any } };

const initialState: state = {
  status: '',
  data: {},
};

export default function reducer(state = initialState, action: FSA<any, any>) {
  switch (action.type) {
    case BOOKABLE_GROUP_FETCH_REQUESTED:
      return { ...state, status: 'loading' };
    case BOOKABLE_GROUP_FETCH_SUCCEEDED:
      return {
        ...state,
        status: 'done',
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case BOOKABLE_GROUP_FETCH_FAILED:
      return { ...state, status: 'failed' };

    case BOOKABLE_GROUP_SAVE_REQUESTED:
      return { ...state, status: 'saving' };
    case BOOKABLE_GROUP_SAVE_SUCCEEDED:
      return {
        ...state,
        status: 'done',
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    case BOOKABLE_GROUP_SAVE_FAILED:
      return { ...state, status: 'failed' };

    case BOOKABLE_GROUP_DELETE_REQUESTED:
      return { ...state, status: 'deleting' };
    case BOOKABLE_GROUP_DELETE_SUCCEEDED: {
      const { [action.payload]: _, ...nonDeleted } = state.data;
      return {
        ...state,
        status: 'done',
        data: {
          ...nonDeleted,
        },
      };
    }
    case BOOKABLE_GROUP_DELETE_FAILED:
      return { ...state, status: 'failed' };

    default:
      return state;
  }
}
